import script from "./ExpandableContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandableContent.vue?vue&type=script&setup=true&lang=ts"

import "./ExpandableContent.vue?vue&type=style&index=0&id=33c39ba0&lang=scss&scoped=true"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c39ba0"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
